import type { ReactNode } from "react";
import Bell from "~icons/ph/bell";
import type { AuthenticatedSnapshot } from "../../shared/types";
import { t } from "../i18n";
import { HistoryRow, PersonRow } from "../people/person-row";
import { useNow } from "../ui/use-now";
import { recentMissedCalls } from "./missed-calls";

function NotificationGroup({
  label,
  rows,
}: {
  label: string;
  rows: ReactNode[];
}) {
  if (!rows.length) return null;
  return (
    <section className="notification-group" aria-label={label}>
      <div className="results-label">
        <span>{label}</span>
      </div>
      {rows}
    </section>
  );
}

export function NotificationsScreen({
  account: { me, history, requests },
}: {
  account: AuthenticatedSnapshot;
}) {
  const now = useNow();
  const missedCalls = recentMissedCalls(history, me.id, now);
  const incoming = requests.filter((p) => p.requested_by !== me.id);
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="app-screen notifications-screen"
      aria-label={t("الإشعارات")}
    >
      <h1>{t("الإشعارات")}</h1>
      {!missedCalls.length && !incoming.length ? (
        <div className="inline-empty screen-empty">
          <Bell width={32} height={32} aria-hidden="true" />
          <p>{t("لا توجد إشعارات بعد.")}</p>
          <small>{t("كل جديد، في مكان واحد.")}</small>
        </div>
      ) : (
        <>
          <NotificationGroup
            label={t("المكالمات الفائتة")}
            rows={missedCalls.map((h) => (
              <HistoryRow key={h.id} call={h} />
            ))}
          />
          <NotificationGroup
            label={t("طلبات الإضافة")}
            rows={incoming.map((p) => (
              <PersonRow key={p.id} person={p} kind="incoming" />
            ))}
          />
        </>
      )}
    </main>
  );
}
